// "Spot the Slip" expansion — FOOD theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_FOOD = [
  ["La sopa es muy caliente, espera.", "La sopa está muy caliente, espera.", "ser-estar",
    "Temperature right now is a changeable state → estar.", "ser-vs-estar"],
  ["El pollo todavía es crudo.", "El pollo todavía está crudo.", "ser-estar",
    "Crudo here is a current condition (not yet cooked) → estar.", "ser-vs-estar"],
  ["Esta paella es deliciosa, mi plato favorito.", "Esta paella es deliciosa, mi plato favorito.", "ser-estar",
    "Trap check: a defining quality of the dish correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["Tengo un sartén nueva.", "Tengo una sartén nueva.", "gender",
    "Sartén is feminine → una sartén.", "gender-agreement-of-nouns"],
  ["La arroz está listo.", "El arroz está listo.", "gender",
    "Arroz is masculine → el arroz.", "gender-agreement-of-nouns"],
  ["Las patatas fritos están ricas.", "Las patatas fritas están ricas.", "gender",
    "Fritas must agree with the feminine plural patatas.", "adjective-agreement"],
  ["Me gusta los plátanos maduros.", "Me gustan los plátanos maduros.", "gustar",
    "The verb agrees with the thing liked; plural bananas → gustan.", "gustar-and-similar-verbs"],
  ["A mí me gustan el queso fuerte.", "A mí me gusta el queso fuerte.", "gustar",
    "One singular thing liked (the cheese) → gusta.", "gustar-and-similar-verbs"],
  ["Compré pan para diez euros.", "Compré pan por diez euros.", "por-para",
    "An exchange of money for goods uses por.", "por-vs-para"],
  ["Esta tarta es para mi madre.", "Esta tarta es para mi madre.", "por-para",
    "Trap check: the recipient of something correctly uses para. (Already correct!)", "por-vs-para"],
  ["¿La sal? Pásala a mí, por favor.", "¿La sal? Pásamela, por favor.", "pronoun-order",
    "Attach indirect + direct together: pása + me + la → pásamela.", "object-pronouns"],
  ["Ayer cocinaba una paella para toda la familia.", "Ayer cociné una paella para toda la familia.", "preterito-imperfecto",
    "A single, completed cooking event takes the pretérito → cociné.", "a2-preterito-vs-imperfecto"],
  ["El platano de la frutería estaba muy maduro.", "El plátano de la frutería estaba muy maduro.", "accents",
    "Plátano is esdrújula, so it always carries a written accent.", "stress-and-written-accents"],
  ["Quiero que la sopa tiene menos sal.", "Quiero que la sopa tenga menos sal.", "subjunctive",
    "A wish about the dish (querer que) triggers the subjunctive → tenga.", "b1-present-subjunctive"],
  ["Busco un restaurante que sirve comida vegana.", "Busco un restaurante que sirva comida vegana.", "subjunctive",
    "An as-yet-unknown place you're looking for triggers the subjunctive → sirva.", "b1-present-subjunctive"],
];
